import { Button } from '@codegouvfr/react-dsfr/Button';
import { useCloseRefOnOuterClick } from '@common/hooks';
import { SelectOption } from '@common/ui';
import React, { useEffect, useRef, useState } from 'react';

export const DropdownSelectionFilter = ({
                                          selection: selectionInput,
                                          options,
                                          onSelectionChange,
                                          buttonLabel,
                                          multiple,
                                          tooltip,
                                        }: DropdownSelectionFilterProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selection, setSelection] = useState<Set<string>>(new Set());

  const ref = useRef<HTMLDivElement>(null!);

  useEffect(() => {
    setSelection(selectionInput);
  }, [selectionInput]);

  /**
   * Permet de close la dropdown si l'on clique en dehors de la ref, pour éviter d'avoir plusieurs filtres ouverts simultanément
   * et ne pas avoir besoin de close manuellement
   */
  useCloseRefOnOuterClick({ ref, setOpen: setIsOpen });

  const handleCheckedChange = (checked: boolean, value: string) => {
    const selectionCopy = (multiple) ? new Set(selection) : new Set();

    if (checked) selectionCopy.add(value);
    else selectionCopy.delete(value);

    onSelectionChange(selectionCopy);
  };

  return (
    <div ref={ref}>
      <Button
        priority="secondary"
        iconId="fr-icon-arrow-down-s-line"
        iconPosition="right"
        className={'uppercase bg-white!'}
        title={tooltip ?? ''}
        onClick={() => setIsOpen?.(s => !s)}>{buttonLabel}</Button>

      {(isOpen) && (
        <div className={'flex flex-col bg-white absolute z-40 shadow-md max-h-[250px] overflow-auto'}>
          {(options.length > 0)
            ? options.map(({ label, value }, index) => (
              <div key={`${label}-${index}-${value}`}
                   className={'cursor-pointer py-3 px-4 hover:bg-[#eee] w-full'}
                   onClick={() => handleCheckedChange(!selection.has(value), value)}>
                <input type="checkbox"
                       className={'fc-checkbox'}
                       checked={selection.has(value)}
                       onChange={(ev) => handleCheckedChange(ev.target.checked, value)} />
                <span className={'no-select'}>{label}</span>
              </div>
            ))
            : <div className={'py-3 px-4'}>Aucun filtre disponible</div>
          }
        </div>
      )}
    </div>
  );
};

interface DropdownSelectionFilterProps {
  options: SelectOption[];
  selection: Set<string>;
  onSelectionChange: (selection: Set<string>) => void;
  buttonLabel: string;
  multiple?: boolean;
  tooltip?: string;
}